// action
export const SAGA_ERROR = 'respondentsaga/ERROR'
export const errorAction = error => ({ type: SAGA_ERROR, error })
